export default __webpack_public_path__ + "static/media/holding_icon.06dfbae0.svg";